// Import components
const taskRouteComponent = () => import('@/pages/agenda/index.vue')

// Redirects configuration
const redirects = [
  {
    path: '/subject/home/:id',
    name: 'subject-home-id',
    redirect: to => ({
      name: 'subject-home-id-tab-subid-slug',
      params: { id: to.params.id, tab: 'announcement' },
    }),
  },
  {
    path: '/lnut/home/subject/:id',
    name: 'lnut-home-subject-id',
    redirect: to => ({
      name: 'lnut-home-subject-id-tab',
      params: { id: to.params.id, tab: 'general' },
    }),
  },
  {
    path: '/lnut/home/:id',
    name: 'lnut-home-id',
    redirect: to => ({
      name: 'lnut-home-id-section-pk-tab',
      params: { id: to.params.id, section: 'subject' },
    }),
  },
  {
    path: '/cicle/home/:id',
    name: 'cicle-home-id',
    redirect: to => ({
      name: 'cicle-home-id-subject-tab-subid-slug',
      params: { id: to.params.id, subject: 'home' },
    }),
  },
]

// Routes configuration
const routes = [
  {
    path: '/agenda/label/:tag',
    name: 'agenda-label-tag',
    component: taskRouteComponent,
  },
  {
    path: '/agenda/filter/:filter',
    name: 'agenda-task-filter',
    component: taskRouteComponent,
  },
]

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default {
  routes: scannedRoutes => [
    ...redirects,
    ...routes,
    ...scannedRoutes,
  ],
}
